export enum ShapeType {
    PREDEFINED_SHAPE = 'Predefined shape',
    DRAWN_SHAPE = 'Drawn shape',
    FAUX_SHAPE = 'Faux shape',
}
